<script>
import { mapState, mapMutations } from "vuex";
import GeneralForm from "@/components/ContractModals/Components/BaseParts/GeneralForm";

export default {
  extends: GeneralForm,
  computed: {
    ...mapState("PurchaseOrderSt2ContractModal", [
      "paymentDelay",
      "minimumServiceAmount",
      "estimatedServiceTime",
      "workScheduleFrom",
      "workScheduleTo"
    ])
  },
  methods: {
    ...mapMutations("PurchaseOrderSt2ContractModal", [
      "setPaymentDelay",
      "setMinimumServiceAmount",
      "setEstimatedServiceTime",
      "setWorkScheduleFrom",
      "setWorkScheduleTo"
    ])
  }
};
</script>
